module.exports = __webpack_public_path__ + "img/report-active.0e3d7bf9.svg";